import { TQuestion } from "../../../api/type"
import QuestionDetailSection from "./QuestionDetailSection"
import "./QuestionListExpandPanel.scss"

type QuestionListExpandPanelProps = {
  question: TQuestion
}

const QuestionListExpandPanel = ({ question }: QuestionListExpandPanelProps) => (
  <div className="question_list__expand">
    <QuestionDetailSection nested title="Answer" html={question.answer} />
    <QuestionDetailSection
      nested
      title="Solution"
      html={question.solution}
      artifacts={question.solution_artifacts}
    />
    <QuestionDetailSection
      nested
      title="Marking scheme"
      html={question.marking_scheme}
    />
  </div>
)

export default QuestionListExpandPanel
